// extracted by mini-css-extract-plugin
export default {"datasetLabel":"SearchPop_datasetLabel__cOE5-","datasetContainer":"SearchPop_datasetContainer__qVFJ1"};